import React, { useState, useEffect, useRef } from "react"
import Autocomplete from "@material-ui/lab/Autocomplete"
import suggestionServices from "../../services/suggestionServices";
import Input from "../Input/Input";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CloseIcon from "@material-ui/icons/Close";

const CommunityTopicCompanyAutocomplete = ({ companyInput, externalDispatch, companyIdx, fieldName, onClear }) => {
  const [options, setOptions] = useState([])
  const [open, setOpen] = useState(false)

  const getCompanies = () => {
    suggestionServices.getAvailableCompanies(companyInput).then(({ data }) => {
      setOptions(
        data
          .slice(0, 20)
          .sort((a, b) => {
            const str1 = a[0]?.toLowerCase()
            const str2 = b[0]?.toLowerCase()
            if (str1 > str2) {
              return 1
            } else if (str1 < str2) {
              return -1
            } else {
              return 0
            }
          })
          .map((company) => ({ id: company[1], name: company[0] })),
      )
    })
  }
  useEffect(() => {
    getCompanies()
    // eslint-disable-next-line
  }, [companyInput])
  
  const handleChevronClick = (e) => {
    e.stopPropagation()
    setOpen(!open)
  }

  return (
    <Autocomplete
      name={`${fieldName}${companyIdx}`}
      inputValue={companyInput}
      options={options}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => {
          return (
          <div ref={params.InputProps.ref}>
            <Input
              name={fieldName || "company"}
              beforeIcon={
                companyInput ? (
                  <div 
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onClear) onClear();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <CloseIcon
                      style={{
                        color: "rgba(255, 255, 255, 0.7)",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </div>
                ) : null
              }
              afterIcon={
                    <div
                      onClick={handleChevronClick}
                      style={{ cursor: "pointer" }}
                    >
                      <KeyboardArrowDownIcon
                        style={{
                          color: "rgba(255, 255, 255, 0.7)",
                        }}
                      />
                    </div>
                }
              type="text"
              placeholder="Enter company"
              {...params.inputProps}
            />
          </div>
        )
      }}
      onInputChange={(e, value) => {
          externalDispatch(value.substring(0, 32))
      }}
      onChange={(e, company, reason) => {
          if (reason === "select-option") {
              externalDispatch(company)
          }
      }}
    />
  )
}
export default CommunityTopicCompanyAutocomplete
